module.exports = __webpack_public_path__ + "img/58.2.TN.3688970a.png";